export default "__VITE_ASSET__CAh2s8fL__"